module.exports = __webpack_public_path__ + "assets/img/five.d09b2324.png";